      $(function() {
	var timestamp = new Date();
	var startCountdown = false;
	var URL = window.location.href;
	var isHomepage = window.location.pathname == '/';
	var isCheckout = (URL.indexOf('/checkouts') > -1 || URL.indexOf('/thank_you') > -1);
	var isCart = URL.indexOf('/cart') > -1;

	var details = {
    	"styles" : '<style>.mobile-hero,.mobile-hero:hover{text-decoration:none}.countdown-mobile,.digit{text-align:center;color:#fff}.mobile-hero{z-index:10;display:block;height:auto;position:relative;background-color:#b90005;border-bottom:1px solid #fff;padding:10px 8px}.countdown-mobile{font-family:Roboto,arial,sans-serif;font-size:20px}.digit{display:inline-block;width:24px;background-color:#444;border-radius:3px;text-shadow:1px 1px #000;margin-top:5px;margin-bottom:5px;height:30px;padding-top:5px}@media(max-width:767px){.countdown-mobile{font-size:13px;}.mobile-hero{z-index:10;display:block;height:auto;position:relative;background-color:#b90005;border-bottom:1px solid #fff;padding:5px 8px}}</style>',
		"saleStart" : new Date("18 June 2021 10:59:59 UTC"),
		"saleEnd" : new Date("16 August 2021 3:59:59 UTC"),
		"landingPage" : 'https://www.nationalsports.com/pages/store-locator'
	}

	var isDuringSaleHours = (timestamp >= details.saleStart) && (timestamp < details.saleEnd);

	var updateClock = function(t) {
		var $hour10 = $('.h-10');
		var $hour01 = $('.h-01');
		var $mins10 = $('.m-10');
		var $mins01 = $('.m-01');
		var $secs10 = $('.s-10');
		var $secs01 = $('.s-01');

		var seconds = Math.floor((t / 1000) % 60);
		var minutes = Math.floor((t / 1000 / 60) % 60);
		var hours   = Math.floor((t / (1000 * 60 * 60)) );
		var days  = Math.floor(t / (1000 * 60 * 60 * 24));

		$hour10.text(Math.floor(hours / 10));
		$hour01.text(hours % 10);

		$mins10.text(Math.floor(minutes / 10));
		$mins01.text(minutes % 10);

		$secs10.text(Math.floor(seconds / 10));
		$secs01.text(seconds % 10);

	}

	var runCountdown = function() {
		$('body').addClass('gtmFix-CountdownClockRunning');
		var countdown = setInterval(function() {
			var now = new Date();
			if ((details.saleEnd - now) >= 0) {
				updateClock(details.saleEnd - now);
			} else {
				clearInterval(countdown);
			}
		}, 100);
	}

	var injectMobileClock = function() {
		var mobileHtmlStr = '';
		mobileHtmlStr += '<a class="mobile-hero" href="' + details.landingPage + '">'
						+ '<div class="countdown-mobile">'
        + 'Pickering Store Closing Sunday August 15th. See Our Store Hours > <br class="add-padding" />'
						//+ '<span class="digit h-10">-</span> '
						//+ '<span class="digit h-01">-</span> : '
						//+ '<span class="digit m-10">-</span> '
						//+ '<span class="digit m-01">-</span> : '
						//+ '<span class="digit s-10">-</span> '
						//+ '<span class="digit s-01">-</span>'
						+ '</div></a>';

		$('head').append(details.styles);
		$('#shopify-section-navigation').after(mobileHtmlStr);
		$('body').addClass('gtmFix-MobileBannerCountdownAdded');
	}

	if (isDuringSaleHours) {
		if (!isCheckout && !isCart) {
			injectMobileClock();
			startCountdown = true;
		}

		if (startCountdown) {
			runCountdown();
		}
	}
});

window.setTimeout(function() {
    window.location.href = 'http://www.sportchek.ca';
}, 10000);